const { prepareVoiceApplication } = require('./voiceApplication');

async function submitVoiceApplication(payload, fetcher = fetch) {
  const application = prepareVoiceApplication(payload);
  const fallback = {
    delivered: false,
    mailto: `mailto:kei@sugano.works?subject=${encodeURIComponent(application.subject)}&body=${encodeURIComponent(application.text)}`,
    applicationText: application.text,
    message: 'フォームから送信できませんでした。入力内容を引き継いでメールで応募できます。下のボタンでメールアプリを開き、内容を確認して送信してください。',
  };
  let response;
  try {
    response = await fetcher('/api/jobs/apply', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (_) { return fallback; }
  // Static hosting and proxy error pages can return HTML, including with status 200.
  if (!/\bapplication\/(?:[\w.-]+\+)?json\b/i.test(response.headers.get('content-type') || '')) return fallback;
  let result;
  try { result = await response.json(); } catch (_) { return fallback; }
  if (response.ok && result?.delivered === true) return { delivered: true };
  if (response.status === 400) throw new Error('入力内容を確認して、もう一度お試しください。');
  return fallback;
}
module.exports = { submitVoiceApplication };
